import { GRAPH_BRANDS_QUERIES } from 'graphql/brands'
import type { BrandsQueriesName, BrandsQueriesData, BrandsQueriesVariables } from 'graphql/brands/types'
import { buildQueryHook } from 'lib/apollo-client/builders'

export const useBrandsQueries = buildQueryHook<BrandsQueriesName, BrandsQueriesVariables, BrandsQueriesData>(
  GRAPH_BRANDS_QUERIES
)
